import classNames from "classnames/bind";
import styles from "./AssistantStartState.module.css";
import React, { type ReactNode } from "react";
import { colours, Icon } from "@validereinc/common-components";

const cx = classNames.bind(styles);

export const AssistantStartState = ({
  greeting,
  promptContent,
}: {
  greeting: ReactNode;
  promptContent: ReactNode;
}) => {
  return (
    <div className={cx("container")}>
      <Icon
        variant="sparkle"
        weight="fill"
        colour={colours.colours.navy[800]}
        size={40}
        style={{ alignSelf: "center" }}
      />
      <h4 className={cx("title")}>Validere Assistant</h4>
      <h6 className={cx("subtitle")}>{greeting}</h6>
      <div aria-label="Prompts">{promptContent}</div>
    </div>
  );
};
